// extracted by mini-css-extract-plugin
export default {"aoi":"NgwosSiteTooltip_aoi__-Zhfl","tooltip":"NgwosSiteTooltip_tooltip__JXCG-","site-clicked":"NgwosSiteTooltip_site-clicked__aaYuo"};